var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      _c("sidebar", { staticClass: "sidebar-container" }),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          _c(
            "div",
            { class: { "fixed-header": _vm.fixedHeader } },
            [_c("navbar"), _vm.needTagsView ? _c("tags-view") : _vm._e()],
            1
          ),
          _c("app-main"),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "el-zoom-in-bottom" } },
        [
          _vm.getmessageShow.messageInfo
            ? _c("SysInfo", {
                key: _vm.getmessageShow.messageInfo,
                attrs: {
                  "message-obj": _vm.getmessageShow,
                  "message-show": _vm.getmessageShow.messageInfo,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("accountCPFTip", { ref: "cpfFromRef" }),
      _c("WarningTrajectoryTip", { ref: "trajectoryRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }